import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["documentViewer"];
  static values = { document_url: String };

  viewDocument() {
    this.documentViewerTarget.classList.remove("hidden");
  }
}
